const WINDSOR_COORDS = { lat: 42.3149, lng: -83.0364 };
const MAX_DISTANCE_KM = 50;

function calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
  const R = 6371;
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

export function isNearWindsor(lat: number, lng: number): boolean {
  const distance = calculateDistance(lat, lng, WINDSOR_COORDS.lat, WINDSOR_COORDS.lng);
  return distance <= MAX_DISTANCE_KM;
}

export async function getUserLocation(): Promise<{ lat: number; lng: number; city: string } | null> {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.log('Geolocation not supported');
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`,
            {
              headers: {
                'User-Agent': 'PrayerTimesApp/1.0'
              }
            }
          );
          const data = await response.json();
          const city = data.address?.city || data.address?.town || data.address?.village || 'Unknown';

          resolve({ lat, lng, city });
        } catch (error) {
          console.error('Error fetching city name:', error);
          resolve({ lat, lng, city: 'Unknown' });
        }
      },
      (error) => {
        console.log('Geolocation error:', error.message);
        resolve(null);
      },
      {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 0
      }
    );
  });
}
